import { render, staticRenderFns } from "./ManuscriptList.vue?vue&type=template&id=22feb959&scoped=true&"
import script from "./ManuscriptList.vue?vue&type=script&lang=ts&"
export * from "./ManuscriptList.vue?vue&type=script&lang=ts&"
import style0 from "./ManuscriptList.vue?vue&type=style&index=0&id=22feb959&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22feb959",
  null
  
)

export default component.exports